var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-item"},[_c('div',{staticClass:"store-flex"},[_c('div',{staticClass:"left"},[_c('PartItem',{attrs:{"styles":{
          width: '182px',
          height: '18px',
          'border-radius': '4px',
          'margin-bottom': '8px',
        }}}),_c('PartItem',{attrs:{"styles":{ width: '182px', height: '14px', 'border-radius': '4px' }}})],1),_c('div',{staticClass:"right"},[_c('PartItem',{attrs:{"styles":{ width: '92px', height: '92px', 'border-radius': '4px' }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }